export function getDefaultSupportTypes(
    organisation: { id: string; name: string; supportTypes: { id: string }[] } | undefined | null,
): string[] {
    return organisation?.supportTypes ? organisation?.supportTypes.map(({ id }) => id) : [];
}
